import { UserOptionDto } from '../../../dto/reference';
import { fetchNotificationRecipientOptions } from '../api/referenceDataApi';
import { useReferenceOptions } from './useReferenceOptions';

export function useNotificationRecipientOptions(enabled = true) {
  return useReferenceOptions<UserOptionDto>(fetchNotificationRecipientOptions, enabled);
}
